import { Components, Theme } from '@mui/material/styles';

export default function MuiSnackbarContent(theme: Theme): Components['MuiSnackbarContent'] {
  return {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.taiga.main,
        color: theme.palette.sand.main,
      },
    },
  };
}
